// import React from 'react';
// import img1 from '../../../Assets/UserSide/Fingertips.png';

// const Alwayshave = () => {
//     return (
//         <>
//             <div className="grid grid-cols-1 lg:grid-cols-2 items-center mx-4 md:mx-16 gap-8">
//                 <div>
//                     <h1 className="text-2xl md:text-4xl font-bold mb-4 text-[#202224]">
//                         Always have us at your Fingertips
//                     </h1>
//                     <p className="text-base md:text-lg mb-4 text-[#6B737A]">
//                         Yostel is designed to simplify the experience for both travelers and hostel management. For guests, it offers easy booking, real-time availability, and seamless check-in/check-out options. Users can browse hostel options, view room details, amenities, and rates, as well as access reviews to make informed choices.
//                     </p>
//                     <p className="text-base md:text-lg font-bold text-[#FF0000] mb-4">
//                         All payments and dues in one place
//                     </p>
//                     <p className="text-base md:text-lg text-[#6B737A]">
//                         This app also features in-app chat for connecting with other travelers, events listings, and local guides to enhance the travel experience. For hostel owners, the app streamlines operations with reservation management, payment processing, and communication tools, ensuring efficient, organized, and customer-focused service.
//                     </p>
//                 </div>
//                 <div>
//                     <img
//                         src={img1}
//                         alt="img"
//                         className="mx-auto w-[80%]"
//                     />
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Alwayshave;

import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import img1 from "../../../Assets/UserSide/Fingertips.png";
import img2 from "../../../Assets/UserSide/playstore.svg"
import img4 from "../../../Assets/UserSide/playstore2.png";
import img3 from "../../../Assets/UserSide/FingertipsBackground.png"
const Alwayshave = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with a duration of 1000ms
  }, []);

  return (
    <div
      className="bg-cover bg-center"
      style={{ backgroundImage: `url(${img3})` }}
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center mx-4 md:mx-16 gap-8 lg:my-20 my-10 py-10">
        <div data-aos="fade-right">
          <h1 className="text-2xl md:text-4xl font-bold mb-4 text-[#202224] xl:w-[70%] w-full">
            <span className="text-[#39A2F7]">Always have</span> us at your
            Fingertips
          </h1>
          <p className="text-base md:text-lg text-[#6B737A] mb-4 xl:w-[85%] w-full">
            Yostel is designed to simplify the experience for both travelers and
            hostel management. For guests, it offers easy booking, real-time
            availability, and seamless check-in/check-out options.
          </p>
          <p className="text-base md:text-lg text-[#6B737A] mb-4 xl:w-[85%] w-full">
            Users can browse hostel options, view room details, amenities, and
            rates, as well as access reviews to make informed choices.
          </p>
          <p className="text-base md:text-lg text-[#6B737A] xl:w-[90%] w-full mb-4">
            This app also feature in-app chat for connecting with other
            travelers, events listings, and local guides to enhance the travel
            experience.
          </p>
         
          <button className="bg-black text-white rounded-md px-3 py-1.5 flex items-center gap-4">
            <img src={img2} alt="playstore" className="object-cover" />
            <span className="flex flex-col text-start ">
              <p className="text-[.6rem] tracking-wide">GET IT ON</p>
              <p className="text-[1.1rem] tracking-wide font-semibold">
                Google Play
              </p>
            </span>
          </button>
        </div>
        <div data-aos="fade-left">
          <img src={img1} alt="img" className="mx-auto w-[80%] object-cover" />
        </div>
      </div>
    </div>
  );
};

export default Alwayshave;
